var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListViewLayout',{attrs:{"title":_vm.$tc('report', 2),"breadcrumbs":_vm.breadcrumbs,"hasQuickActionBar":false,"hasPagination":false}},[_c('div',{staticClass:"m-4"},[_vm._v(" Under construction... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }